(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-subcollection-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
  if (window.__hwDrawerReady) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};
  var lastFocus = null;

  function q(sel, ctx) { return (ctx || document).querySelector(sel); }

  var drawer = q('[data-hw-drawer]');
  var scrim = q('[data-hw-scrim]');
  if (!drawer || !scrim) return;
  window.__hwDrawerReady = true;

  var slot = q('[data-hw-slot]', drawer);
  var loading = q('[data-hw-loading]', drawer);
  var chipBar = q('[data-hw-chips]', drawer);
  var elTitle = q('[data-hw-title]', drawer);
  var elParent = q('[data-hw-parent]', drawer);
  var elCount = q('[data-hw-count]', drawer);
  var elThumb = q('[data-hw-thumb]', drawer);
  var elAll = q('[data-hw-all]', drawer);
  var body = q('[data-hw-body]', drawer);

  function setCount(n) {
    elCount.textContent = n + (n === 1 ? ' piece' : ' pieces');
  }

  function buildChips() {
    var cards = slot.querySelectorAll('.hw-card');
    var types = [];
    cards.forEach(function (c) {
      var t = (c.getAttribute('data-type') || '').trim();
      if (t && types.indexOf(t) === -1) types.push(t);
    });
    chipBar.innerHTML = '';
    if (types.length < 2) { chipBar.hidden = true; return; }
    types.unshift('All pieces');
    types.forEach(function (t, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hw-chip';
      b.textContent = t;
      b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      b.addEventListener('click', function () {
        chipBar.querySelectorAll('.hw-chip').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        var shown = 0;
        cards.forEach(function (c) {
          var match = i === 0 || (c.getAttribute('data-type') || '').trim() === t;
          c.classList.toggle('is-hidden', !match);
          if (match) shown++;
        });
        setCount(shown);
      });
      chipBar.appendChild(b);
    });
    chipBar.hidden = false;
  }

  function render(html) {
    slot.innerHTML = html;
    loading.hidden = true;
    setCount(slot.querySelectorAll('.hw-card').length);
    buildChips();
    body.scrollTop = 0;
  }

  function load(handle) {
    if (cache[handle]) { render(cache[handle]); return; }
    loading.hidden = false;
    slot.innerHTML = '';
    chipBar.hidden = true;
    fetch(root.replace(/\/$/, '') + '/collections/' + handle + '?view=hw-cards', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { cache[handle] = html; render(html); })
      .catch(function () {
        loading.hidden = true;
        slot.innerHTML = '<p style="opacity:.6;font-size:.85rem">Could not load these products. <a href="' + root.replace(/\/$/, '') + '/collections/' + handle + '">Open the collection page</a>.</p>';
      });
  }

  function open(el) {
    lastFocus = document.activeElement;
    var handle = el.getAttribute('data-handle');
    elTitle.textContent = el.getAttribute('data-title') || '';
    elParent.textContent = el.getAttribute('data-parent') || '';
    elCount.textContent = '';
    var thumb = el.getAttribute('data-thumb');
    elThumb.style.backgroundImage = thumb ? 'url("' + thumb + '")' : 'none';
    elAll.setAttribute('href', root.replace(/\/$/, '') + '/collections/' + handle);
    scrim.hidden = false;
    requestAnimationFrame(function () { scrim.classList.add('is-on'); });
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('hw-locked');
    q('[data-hw-close]', drawer).focus();
    load(handle);
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    scrim.classList.remove('is-on');
    document.body.classList.remove('hw-locked');
    setTimeout(function () { scrim.hidden = true; }, 400);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var sub = e.target.closest && e.target.closest('[data-hw-sub]');
    if (sub) { e.preventDefault(); open(sub); return; }
    if (e.target.closest && e.target.closest('[data-hw-close]')) { close(); return; }
    if (e.target === scrim) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // theme editor re-renders the section without a page load
  document.addEventListener('shopify:section:load', init);
}());

  } catch(e) { console.error(e); }
})();
})();
